<template>
    <div v-if="ready">
        <form
            class="form-horizontal fr-absolute"
            enctype="multipart/form-data"
            @submit.prevent="store"
            @keydown="form.errors.clear($event.target.name)"
            novalidate
            autocomplete="off"
        >
            <div class="row">
                <div class="col-md-3 col-xl-2 col-sm-12 col-form-label"></div>
                <div class="col-md-9 col-xl-10 col-sm-12" style="display: flex; align-items: center;">
                    <div style="display: flex; align-items: center;">
                        <span style="font-weight:bold; width:125px">Backoffice</span>
                        <span style="font-weight:bold; width:125px">Trajectmanager</span>
                        <span style="font-weight:bold; width:125px">Kandidaat</span>
                        <span style="font-weight:bold; width:125px">Opdrachtgever</span>
                    </div>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-md-3 col-xl-2 col-sm-12 col-form-label"><span>Wie heeft toegang</span></div>
                <div class="col-md-9 col-xl-10 col-sm-12" style="display: flex; align-items: center;">
                    <div style="display: flex; align-items: center;">
                        <span style="width:125px">
                            <!-- Backoffice -->
                            <input type="checkbox" :disabled="disableBackofficeComputed" v-model="form.who_can_see.backoffice">
                        </span>
                        <span style="width:125px">
                            <!-- Trajectmanager -->
                            <input type="checkbox" :disabled="disableTrajectoryManagerComputed" v-model="form.who_can_see.trajectory_manager">
                        </span>
                        <span style="width:125px">
                            <!-- Kandidaat -->
                            <input type="checkbox" :disabled="disableCandidate" v-model="form.who_can_see.candidate">
                        </span>
                        <span style="width:125px">
                            <!-- Opdrachtgever -->
                            <input type="checkbox" :disabled="disableClient" v-model="form.who_can_see.employer">
                        </span>
                        <span>
                            <i class="fa fa-2x fa-info-circle text-brand" @click="showInfoModal"></i>
                        </span>
                    </div>
                </div>
            </div>

            <backend-select
                :error="form.errors.get('log_category_id')"
                required
                v-model="selected_category"
                name="log_category"
                label="log_category"
                :route="route('logs.categories.indexForSelect')"
                :disabled="isFromLogbookReminder"
            />

            <form-textarea
                :form="form"
                label="subject_or_short_description"
                name="subject"
                :required="true"
                :disabled="isFromLogbookReminder"
            />

            <!-- Reminder: HTML-able editor, editable, prefill shown as visual HTML -->
            <template v-if="isFromLogbookReminder">
                
                <div class="form-group row" :class="{ 'has-danger': form.errors.has('body') }">
                    <label class="col-md-3 col-xl-2 col-sm-12 col-form-label" for="body">
                        {{ uLang('app.body_or_explanation') }}: *
                    </label>
                    <div class="col-md-9 col-xl-10 col-sm-12">
                        <div class="log-form-ckeditor">
                            <raw-ckeditor
                                v-model="form.body"
                            />
                        </div>
                        <span class="help-block form-control-feedback" v-if="form.errors.has('body')" v-text="form.errors.get('body')"></span>
                    </div>
                </div>
            </template>
            <!-- Non-reminder: plain textareas -->
            <template v-else>
                
                <form-textarea
                    :form="form"
                    label="body_or_explanation"
                    name="body"
                    :required="true"
                />
            </template>

            <div class="form-group row" v-if="shouldShowDurationField">
                <label for="duration" class="col-form-label col-md-3 col-xl-2 col-sm-12">
                {{ uLang('app.duration') }}:
                </label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <input type="hidden" v-model="form.durations_per_enrolment['key_0']" value="0" />
                    <div v-for="enrolment in form.active_enrolments" :key="enrolment.id">
                        <TimeInput
                            v-model="form.durations_per_enrolment['key_' + enrolment.id]"
                            :name="`durations_per_enrolment_${enrolment.id}`"
                            :required="true"
                            :label="uLang('app.trajectory') + ': ' + enrolment.trajectory_project.name + ' - ' + enrolment.trajectory.name"
                            labelPosition="right"
                        />
                    </div>
                </div>
            </div>
            <div v-else-if="isCreating">
                <label for="duration" class="col-form-label col-md-3 col-xl-2 col-sm-12">
                    {{ uLang('app.duration') }}:
                </label>
                <div class="col-md-9 col-xl-10 col-sm-12">
                    <span class="text-muted">No active enrolments yet</span>
                </div>
            </div>
            <div class="form-group row" v-else></div>

            <div class="row form-group">
                <div class="col-md-3 col-xl-2 col-sm-12 col-form-label">Opnemen in rapportage: *</div>
                <div class="col-md-9 col-xl-10 col-sm-12" style="display: flex; align-items: center;">
                    <div style="display: flex; align-items: center;">
                        <select :disabled="this.form.who_can_see.backoffice == 0 || this.form.who_can_see.trajectory_manager == 0 || this.form.who_can_see.candidate == 0 || this.form.who_can_see.employer == 0 "
                        id="reporting_log_select"
                        ref="reporting_log_select"
                        v-model="form.reporting_log"
                        name="reporting_log"
                        style="padding:6px; width:250px; border: 1px solid #ccc;">
                            <option :value="1">Ja</option>
                            <option :value="0">Nee</option>
                        </select>
                        <span>
                            <i class="fa fa-info-circle" style="margin-left:20px; color:#ccc"></i>
                            Kan alleen op Ja gezet worden als alle 4 de rollen toegang hebben
                        </span>
                    </div>
                </div>
            </div>

            <template v-if="(id === null  || typeof id === 'undefined')">
                <div class="row">
                    <div class="col-md-3 col-xl-2 col-sm-12"></div>
                    <div class="col-md-9 col-xl-10 col-sm-12">
                        <div class="my-4 info-message text-muted">
                            <i class="fa fa-lg fa-info-circle"></i>
                            <p>{{ uLang('app.relation_or_departments_to_inform_explanation') }}</p>
                        </div>
                    </div>
                </div>

                <div class="row" v-if="isFromLogbookReminder && reminderType == 'IG'">
                    <div class="col-md-3 col-xl-2 col-sm-12"></div>
                    <div class="col-md-9 col-xl-10 col-sm-12">
                        <div class="my-4 info-message text-muted">
                            <!-- FontAwesome 4.7 does NOT have outlined version for fa-exclamation-circle, so we need to use a stack with fa-circle-o and fa-exclamation -->
                            <span class="fa-stack fa-lg">
                                <i class="fa fa-circle-o fa-stack-1x"></i>
                                <i class="fa fa-exclamation fa-stack-1x fa-exclamation-small"></i>
                            </span>
                            <p class="text-600">{{ uLang('app.email_to_organisation_explanation_for_ig_reminder') }}</p>
                        </div>
                    </div>
                </div>

                <!-- Reminder mode: NO route, only coach (TrajectoryManager), disabled -->
                <dual-select
                    v-if="isFromLogbookReminder"
                    inputLabel="app.relations"
                    :error="form.errors.get('relations')"
                    name="relations"
                    :options="reminderCoachOptions"
                    v-model="form.relations"
                    :disabled="true"
                />

                <!-- Standard mode: any other situations -->
                <dual-select
                    v-else
                    inputLabel="app.relations"
                    :error="form.errors.get('relations')"
                    name="relations"
                    :route="entityRelations"
                    v-model="form.relations"
                />

                <!-- Reminder mode: don’t show departments at all -->
                <!-- It was: v-if="!isFromLogbookReminder" but now they want it for reminders too -->
                <dual-select
                    inputLabel="app.departments"
                    :error="form.errors.get('departments')"
                    name="departments"
                    :options="departments"
                    :route="entityDepartments"
                    v-model="form.departments"
                    labelKey="display_name"
                />
            </template>

            <form-date-picker
                :form="form"
                name="reminder"
                label="reminder"
                initial-view="day"
                :disabled="reminderDisabled"
            />

            <form-date-picker
                :form="form"
                name="action_date"
                label="action_date"
                initial-view="day"
                required
                :disabled="actionDateDisabled"
            />

            <div class="form-group fr-absolute">
                <input
                    :disabled="form.busy"
                    type="submit"
                    class="btn btn-brand"
                    @click.prevent="store()"
                    :value="uLang('app.save')"
                />
            </div>
        </form>
    </div>
</template>

<script>
import {
    Input as FormInput,
    Textarea as FormTextarea,
    DualSelect,
    SettingSelect,
    ActionDocumentSelect,
} from '~/Form/elements'
import Form from '~/Form/Form'
import FormMixin from '~/mixins/form'
import moment from 'moment'
import {SuccessfullyStoredAlert, SuccessfullyUpdatedAlert, WarningAlert} from "~/Swals"
import YesNoSelect from "../../elements/selects/yes-no";
import Swal from 'sweetalert'
import TimeInput from "../../elements/selects/TimeInput.vue";
import RawCkeditor from "~/components/elements/raw-ckeditor.vue";

export default {
    name: 'LogForm',

    mixins: [FormMixin],

    components: {
        YesNoSelect,
        FormInput,
        FormTextarea,
        DualSelect,
        SettingSelect,
        ActionDocumentSelect,
        TimeInput,
        RawCkeditor,
    },

    props: {
        id: { required: false },
        entityType: { type: String, required: true },
        entityId: { required: true },

        trajectoryEnrolment: { type: Object, default: null },
        actionProgress: { type: Object, default: null },
        prefillSubject: { type: String, default: '' },
        prefillBody: { type: String, default: '' },

        // For Reminders (ID-369)
        isFromLogbookReminder: { type: Boolean, default: false },
        reminderType: {
            type: String,
            default: null,
            validator: v => v === null || ['R1', 'R2', 'IG', 'NvT'].includes(v),
        },
    },

    data() {
        return {
            entity: 'log',
            form: new Form({
                entity_type: '',
                entity_id: null,
                reporting_log_type: null,
                reporting_log_activity_type: null,
                log_category_id: null,
                activity_date: new Date(),
                action_date: new Date(),
                reminder: '',
                action_progress_ids: [],
                subject: '',
                relations: [],
                body: '',
                departments: [],
                reporting_log: false,
                durations_per_enrolment: {},
                who_can_see: {
                    backoffice: true,
                    trajectory_manager: true,
                    candidate: !!$hasType('candidate') ?? false,
                    employer: !!$hasType('client') ?? false
                },
                appearsInReports: [],
                active_enrolments: [],

                // For reminder checkboxes:
                is_from_logbook_reminder: false,
                reminder_type: null, // 'R1' | 'R2' | 'IG' | 'NvT'
                reminder_action_progress_id: null,
            }),
            baseUri: '',
            selected_category: null,
            resetForm: false,
            departments: [],
        };
    },

    watch: {
        entityType: { handler: 'setFormEntityType', immediate: true },
        entityId: { handler: 'setFormEntityId', immediate: true },

        selected_category(newValue) {
            this.form.log_category_id = null;
            if(newValue) {
                let parsedValue = newValue == null ? null : newValue.id;
                this.form.log_category_id = parsedValue;
            }
        },

        'form.who_can_see': {
            handler() { this.checkDisable(); },
            deep: true,
        },
    },

    computed: {
        entityRelations() {
            return route('logs.relations', {entity: this.entityType, entity_id: this.entityId})
        },
        entityDepartments() {
            return route('logs.departments', {entity: this.entityType, entity_id: this.entityId})
        },

        isLogForRelation() {
            return this.entityType === 'relations';
        },

        /* reminder mode: force disable these two only */
        disableBackofficeComputed() {
            return this.isFromLogbookReminder ? true : false;
        },
        disableTrajectoryManagerComputed() {
            return this.isFromLogbookReminder ? true : !!$hasType('coach');
        },

        disableBackoffice() { return false },
        disableTrajectoryManager() { return !!$hasType('coach') },
        disableCandidate() { return !!$hasType('candidate') },
        disableClient() { return !!$hasType('client') },

        isReportingLog() { return !!this.form.reporting_log },

        isCreating() {
            return !this.id;
        },

        shouldShowDurationField() {
            return this.form.active_enrolments.length > 0;
        },

        actionDateDisabled() {
            return this.isFromLogbookReminder;
        },

        reminderDisabled() {
            // Now they ask to allow edit it for all remninder types
            return false;
            //   but keep old logic just in case:
            // R1/R2/IG fixed, NvT blank + editable
            // return this.isFromLogbookReminder && this.reminderType !== 'NvT';
        },

        reminderCoachOptions() {
            const coach = this.trajectoryEnrolment?.trajectory_manager || null;
            const coachId = this.trajectoryEnrolment?.trajectory_manager_id || coach?.id || null;

            const label =
                coach?.full_name
                || coach?.name
                || coach?.email
                || (coachId ? `Relation #${coachId}` : 'Coach');

            if (!coachId) return [];

            return [{
                id: coachId,
                full_name: label
            }];
        },
    },

    created: function () {
        this.departments = window.config.departments;

        this.$on('afterStore', this.afterStore);
        this.$on('afterUpdate', this.afterUpdate);
        this.$on('onError', this.onError);
        this.$on('afterRetrieve', this.afterRetrieve);

        if (this.isFromLogbookReminder) {
            this.applyReminderDefaults();
            
            this.swal = false; // disable the generic mixin Swal as we will use a custom one in the checkboxes component

            // fetch the category id and autoselect it
            this.setRappelCategoryFromBackend();

            // do NOT fetch active enrolments for reminder modal - it's showing the received one
        } else {
            this.fetchTrajectoryEnrolments();
        }
    },

    methods: {
        applyReminderDefaults() {
            // category: rappel
            // this.form.log_category_id = 265;

            // fixed subject and body texts (disallow changes in UI by disabled props)
            if (this.prefillSubject) this.form.subject = this.prefillSubject;
            if (this.prefillBody) this.form.body = this.prefillBody;

            // access: backoffice + trajectmanager forced checked
            this.form.who_can_see.backoffice = true;
            this.form.who_can_see.trajectory_manager = true;

            // relations to inform = coach only
            const coachId = this.trajectoryEnrolment?.trajectory_manager_id
                || this.trajectoryEnrolment?.trajectory_manager?.id
                || null;

            this.form.relations = coachId ? [coachId] : [];

            // dates
            const today = new Date();
            this.form.action_date = today;

            if (this.reminderType === 'R1') {
                this.form.reminder = this.addDays(today, 5);
            } else if (this.reminderType === 'R2' || this.reminderType === 'IG') {
                this.form.reminder = this.addDays(today, 3);
            } else if (this.reminderType === 'NvT') {
                // blank + editable
                this.form.reminder = '';
            }

            this.form.reminder_type = this.reminderType;
            this.form.is_from_logbook_reminder = true;
            this.form.reminder_action_progress_id = this.actionProgress?.id || null;
        },

        async setRappelCategoryFromBackend() {
            // Only used in Reminder mode
            if (!this.isFromLogbookReminder) return;

            const category_name = 'Rappel';

            try {
                const { data } = await axios.get(route('get-category-by-name'), {
                    params: { name: category_name }
                });

                const id = (data && typeof data === 'object') ? data.id : data;
                if (!id) return;

                // Set both (your existing pattern)
                this.form.log_category_id = id;
                this.selected_category = { id };

                // ---- Stabilizer: wait for backend-select options, then re-apply selection ----
                // We *don't* change backend-select, so we "nudge" it until it's ready.
                const start = Date.now();
                const timeoutMs = 2500;     // total time we try
                const intervalMs = 80;      // how often we retry

                const findBackendSelect = () => {
                    // Find the backend-select instance for log_category
                    // (works without adding refs)
                    const stack = [...(this.$children || [])];

                    while (stack.length) {
                        const c = stack.shift();
                        if (!c) continue;

                        const isBackendSelect =
                            (c.$options && (c.$options.name === 'backend-select' || c.$options._componentTag === 'backend-select'))
                            || (c.$vnode && c.$vnode.tag && String(c.$vnode.tag).includes('backend-select'));

                        const isLogCategory =
                            (c.$attrs && c.$attrs.name === 'log_category') ||
                            (c.$props && (c.$props.name === 'log_category' || c.$props.label === 'log_category'));

                        if (isBackendSelect && isLogCategory) {
                            return c;
                        }

                        if (c.$children && c.$children.length) {
                            stack.push(...c.$children);
                        }
                    }

                    return null;
                };

                const hasOptionsLoaded = (cmp) => {
                    if (!cmp) return false;

                    // Try common option containers (we don't know its internals)
                    const candidates = [
                        cmp.options,
                        cmp.items,
                        cmp.list,
                        cmp.data,
                        cmp.results,
                        cmp.$data && cmp.$data.options,
                        cmp.$data && cmp.$data.items,
                        cmp.$data && cmp.$data.list,
                    ];

                    for (const v of candidates) {
                        if (Array.isArray(v) && v.length > 0) return true;
                    }

                    // As last resort: if it has some "loading" flag, wait until it's false
                    if (typeof cmp.loading === 'boolean') return !cmp.loading;
                    if (cmp.$data && typeof cmp.$data.loading === 'boolean') return !cmp.$data.loading;

                    // Unknown internals -> assume not loaded yet
                    return false;
                };

                // Wait a tick so backend-select is mounted/updated
                await this.$nextTick();

                return await new Promise((resolve) => {
                    const tick = async () => {
                        const cmp = findBackendSelect();

                        // If options are now available, re-apply the selection one final time
                        if (cmp && hasOptionsLoaded(cmp)) {
                            // Re-apply after options exist so it can match and display
                            this.selected_category = { id };
                            this.form.log_category_id = id;

                            await this.$nextTick();
                            return resolve(true);
                        }

                        // Timeout: stop retrying, but still "nudge" a couple of times
                        if (Date.now() - start > timeoutMs) {
                            // One last best-effort nudge (sometimes options arrive slightly after)
                            setTimeout(() => { this.selected_category = { id }; }, 150);
                            setTimeout(() => { this.selected_category = { id }; }, 350);
                            return resolve(false);
                        }

                        setTimeout(tick, intervalMs);
                    };

                    tick();
                });

            } catch (e) {
                console.error('Failed to load Rappel category id from backend', e);
            }
        },
        // async setRappelCategoryFromBackend() {
        //     // Only used in Reminder mode
        //     if (!this.isFromLogbookReminder) return;

        //     const category_name = 'Rappel';

        //     try {
        //         const { data } = await axios.get(route('get-category-by-name'), { 
        //                                 params: { name: category_name } 
        //                             });

        //         console.log(`Get category ID for ${category_name}: ${data}`);

        //         // Accepts { id: 123 } or 123 or null
        //         const id = (data && typeof data === 'object') ? data.id : data;

        //         if (!id) {
        //             return;
        //         }

                
        //         // Also set the v-model so backend-select displays it once options are loaded
        //         this.selected_category = { id: id };

        //         // wait a tick so backend-select can react
        //         await this.$nextTick();

        //         // Set the form FK
        //         this.form.log_category_id = id;


        //         console.log(`Rappel category ID set to ${id}`);
        //         console.log(`Rappel selected_category ID set to ${this.selected_category}`);
        //         console.log(`Rappel form.log_category_id ID set to ${this.form.log_category_id}`);

        //     } catch (e) {
        //         console.error('Failed to load Rappel category id from /get-rappel-category', e);
        //     }
        // },

        addDays(dateObj, days) {
            const d = new Date(dateObj.getTime());
            d.setDate(d.getDate() + days);
            return d;
        },

        checkDisable() {
            if(this.form.who_can_see.backoffice == false ||
                this.form.who_can_see.trajectory_manager == false ||
                this.form.who_can_see.candidate == false ||
                this.form.who_can_see.employer == false)
            {
                this.form.reporting_log = 0;
                this.$refs.reporting_log_select.disabled = true;
            }
            else
            {
                this.$refs.reporting_log_select.disabled = false;
            }
        },

        currentReportingLogTypeIs(type) {
            return type === $getIfExists(this.selected_reporting_log_type, 'system_name');
        },

        afterStore(response) {
            // reset form
            this.form.fill({
                'log_category_id': null,
                'subject': '',
                'body': '',
                'reporting_log': 0,
                'relations': [],
                'departments': []
            });

            // inform parent: this closes the modal and refreshes the list/table in the parent
            this.$emit('logCreated', response);
        },

        showInfoModal() {
            Swal({
                title: uLang('app.information_permission_system'),
                text: uLang('app.information_permission_system_text_part_1') + '\n' + uLang('app.information_permission_system_text_part_2'),
                icon: 'info'
            })
        },

        afterUpdate(response) {
            if (this.isLogForRelation) {
                this.$router.push({name: 'admin.relations.view', params: {id: this.entityId}});
            } else {
                this.$router.push({name: 'admin.organisations.view', params: {id: this.entityId}});
            }
        },

        onError() {
            new WarningAlert({'title': uLang('app.validation_error'), 'text': uLang('app.fill_all_fields')}).show()
        },

        afterRetrieve(log) {
            this.selected_category = log.log_category_id;
            this.form.relations = log.relations.map((relation) => relation.id);
            this.form.reporting_log_type = log.reporting_log_type_id;
            this.form.activity_date = moment(log.activity_date, 'DD-MM-YYYY')._d;
            this.form.action_date = moment(log.action_date, 'YYYY-MM-DD')._d;
            this.form.reminder = !log.reminder ? '' : moment(log.reminder, 'YYYY-MM-DD')._d;
            this.form.reporting_log_activity_type = log.log_subcategory_id;
            this.selected_reporting_log_type = log.reporting_log_type_id;
            this.form.who_can_see = JSON.parse(log.who_can_see);
            this.form.reporting_log = log.reports.length > 0 ? 1 : 0;
        },

        setFormEntityType(newValue) { this.form.entity_type = newValue },
        setFormEntityId(newValue) { this.form.entity_id = newValue },

        async fetchTrajectoryEnrolments() {
            try {
                const response = await axios.get(`/api/admin/relations/${this.entityId}/active_enrolments`)
                    .then(response => {
                        this.form.active_enrolments = response.data.active_enrolments;
                        this.form.durations_per_enrolment = {};

                        for (const enrolment of this.form.active_enrolments) {
                            const enrolmentId = String(enrolment.id);

                            if (!this.isCreating) {
                                const matchingLog = enrolment.time_logs.find(log => log.log_id == this.id);
                                this.$set(this.form.durations_per_enrolment, 'key_' + enrolmentId, matchingLog ? matchingLog.time : null);
                            } else {
                                this.$set(this.form.durations_per_enrolment, 'key_' + enrolmentId, null);
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Failed to load active enrolments:', error);
                    });
            } catch (error) {
                console.error('Failed to load trajectory enrolments:', error);
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.info-message {
    display: flex;
    align-items: center;

    i { padding-right: 15px; }
    p { flex: 1; margin-bottom: 0; }
}


/* Match form-control border on CKEditor containers */
.log-form-ckeditor::v-deep .editor-container {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
}

.fa-exclamation-small {
    transform: scale(0.60);
    left: -2.6px !important;
}

.text-600 {
     font-weight: 600;
}
</style>
